import { useEffect, useState } from "react";
import type { SeriesId, TaskId, TaskView } from "../api/generated";
import type { TaskApi } from "../api/taskApi";
import { describeWhen } from "../domain/when";

interface SeriesHistoryProps {
  api: Pick<TaskApi, "seriesInstances">;
  seriesId: SeriesId;
  currentId: TaskId;
  now: Date;
  /** Changes whenever the replica does, so the history stays current. */
  revision: unknown;
  onSelect(id: TaskId): void;
}

export function SeriesHistory({ api, seriesId, currentId, now, revision, onSelect }: SeriesHistoryProps) {
  const [instances, setInstances] = useState<TaskView[]>([]);

  useEffect(() => {
    let cancelled = false;
    void api.seriesInstances(seriesId).then((found) => {
      if (!cancelled) setInstances(found);
    });
    return () => {
      cancelled = true;
    };
  }, [api, seriesId, revision]);

  return (
    <section className="panel" aria-labelledby="history-heading">
      <h3 id="history-heading">Series history</h3>
      <ol style={{ margin: 0, padding: 0, listStyle: "none" }}>
        {instances.map((instance) => {
          const index = instance.task.series?.index ?? 0;
          const due = instance.task.due === undefined ? "no date" : describeWhen(instance.task.due, now).text;
          return (
            <li key={instance.task.id}>
              <button
                type="button"
                className={`series-instance nav-item${instance.task.id === currentId ? " current" : ""}`}
                aria-current={instance.task.id === currentId ? "true" : undefined}
                onClick={() => onSelect(instance.task.id)}
              >
                <span>
                  #{index + 1} · {due}
                </span>
                <span className="status">{instance.status}</span>
              </button>
            </li>
          );
        })}
      </ol>
    </section>
  );
}
